import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl, InputLabel, Input, InputAdornment, IconButton,
} from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Refresh from '@material-ui/icons/Refresh';
import { withStyles } from '@material-ui/core/styles';
import { checkPassword, getStrongPassword } from '../../util';


class PasswordConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      passwordChanged: false,
    };
  }

  get showError() {
    const { value, password } = this.props;
    const { passwordChanged } = this.state;
    return passwordChanged && password !== value;
  }

  onChange = (pw) => {
    const { onChange } = this.props;
    this.setState({ passwordChanged: true });
    onChange(pw);
  }

  renderError = () => {
    const { classes, value } = this.props;
    if (!this.showError) {
      return null;
    }
    return (
      <div className={classes.errorMessage}>
        Passwörter stimmen nicht überein!
      </div>
    );
  }

  render() {
    const {
      classes, onChange, label, value, canHidePassword,
    } = this.props;
    const { showPassword } = this.state;
    return (
      <div>
        <div className={classes.container}>
          <FormControl className={classes.formControl}>
            <InputLabel shrink>{label}</InputLabel>
            <Input
              autoComplete="new-password"
              type={canHidePassword && !showPassword ? 'password' : 'text'}
              value={value || ''}
              onChange={e => this.onChange(e.target.value)}
              className={classes.root}
              endAdornment={canHidePassword && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={() => this.setState({ showPassword: !showPassword })}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )}
              error={this.showError}
            />
          </FormControl>
        </div>
        {this.renderError()}
      </div>
    );
  }
}

PasswordConfirm.propTypes = {
  classes: PropTypes.object.isRequired,
  password: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  canHidePassword: PropTypes.bool,
  onChange: PropTypes.func,
};

PasswordConfirm.defaultProps = {
  value: '',
  label: '',
  password: '',
  canHidePassword: false,
  onChange: () => {},
};

const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  root: {
    marginTop: 14,
    display: 'flex',
    'label[data-shrink=false] + & ::-webkit-input-placeholder': {
      opacity: '0.5 !important',
    },
  },
  errorMessage: {
    color: red[500],
    fontSize: 10,
    marginTop: 3,
  },
  formControl: {
    width: '100%',
    marginTop: 14,
  },
});

export default withStyles(styles)(PasswordConfirm);
